import { connect } from 'react-redux';

import EventPeriods from '../../components/event/period/EventPeriods';
import {
  getGlobalFilter,
  getPeriodsState,
  getProjectZoneId,
  getUniqueChar,
} from '../../reducers/analyticsApp';
import {
  addPeriod,
  deletePeriod,
  setPeriod,
  copyPeriods,
  setShowPeriods,
} from '../../actions/events/events';
import { setEventSplitColumn } from '../../actions/events/csvEvents';

const mapStateToProps = (state, { id }) => {
  const { periods, isShow } = getPeriodsState(state, id);

  return {
    periods,
    isShow,
    uniqueChar: getUniqueChar(state, id),
    zoneId: getProjectZoneId(state),
    globalFilter: getGlobalFilter(state),
  };
};

const mapDispatchToProps = (dispatch, { id }) => ({
  addPeriod: () => dispatch(addPeriod(id)),
  setPeriod: (index, from, to) => dispatch(setPeriod(id, index, from, to)),
  deletePeriod: (index) => dispatch(deletePeriod(id, index)),
  setShow: (value) => dispatch(setShowPeriods(id, value)),
  onChangeSplitColumn: (value) => dispatch(setEventSplitColumn(id, value)),
  onCopyPeriod: (periods) => dispatch(copyPeriods(id, periods)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventPeriods);
